module.exports = __webpack_public_path__ + "static/img/far2_active.0ef1d422.png";